import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosInstance } from "..";
import toast from "react-hot-toast";
import messages from "../../assets/Local/Local";

const initialState = {
  ProposalStageList: [],
  singleProposal: null,
  totalRecords: 0,
};

export const getBusinessResourcesProposalList = createAsyncThunk(
  "businessResource/ProposalStageList",
  async (params) => {
    return await axiosInstance.get("Projects/Proposal/" + params.stageId, {
      params,
    });
  }
);
export const getSingleBusinessResourceProposal = createAsyncThunk(
  "businessResource/singleProposalStage",
  async (projectId) => {
    return await axiosInstance.get(
      `Projects/GetAllProjectDetails/${projectId}`
    );
  }
);
export const addEditProjectAllocation = createAsyncThunk(
  "businessResource/addAllocation",
  async (data, { dispatch }) => {
    return await axiosInstance
      .post(`Projects/AddEditProjectAllocation`, data)
      .then(() => {
        toast.success(messages[localStorage.getItem("lang")].shared.done);

        dispatch(getBusinessResourcesProposalList);
      })
      .catch((error) => {
        toast.error(error.response.data.error.message);
        return error;
      });
  }
);
export const submitAllocationRequest = createAsyncThunk(
  "businessResource/submitAllocation",
  async (projectId, { dispatch }) => {
    return await axiosInstance
      .post(`Projects/SubmitAllocationRequest/${projectId}`)
      .then(() => {
        toast.success(messages[localStorage.getItem("lang")].shared.done);
      })
      .catch((error) => {
        toast.error(error.response.data.error.message);
        return error;
      });
  }
);
export const addInvoice = createAsyncThunk(
  "businessResource/addInvoice",
  async (data, { dispatch }) => {
    return await axiosInstance
      .post(`Projects/AddInvoice/${data.projectId}/${data.isIssued}`, data)
      .then(() => {
        toast.success(messages[localStorage.getItem("lang")].shared.done);
        dispatch(
          getBusinessResourcesProposalList({
            Page: 1,
            PageSize: 10,
            stageId: 2,
          })
        );
      })
      .catch((error) => {
        toast.error(error.response.data.error.message);
        return error;
      });
  }
);

export const updateProjectDuration = createAsyncThunk(
  "businessResource/UpdateProjectduration",
  async (data, { dispatch }) => {
    return await axiosInstance
      .put(`Projects/UpdateProjectduration/${data.id}`, data)
      .then(() => {
        toast.success(messages[localStorage.getItem("lang")].shared.done);
        dispatch(
          getSingleBusinessResourceProposal()
        );
      })
      .catch((error) => {
        toast.error(error.response.data.error.message);
        return error;
      });
  }
);

const BusinessResourceSlice = createSlice({
  name: "businessResource",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(
      getBusinessResourcesProposalList.fulfilled,
      (state, action) => {
        state.ProposalStageList = action.payload.data.data;
        state.totalRecords = action.payload.data.totalRecords;
      }
    );
    builder.addCase(
      getSingleBusinessResourceProposal.fulfilled,
      (state, action) => {
        state.singleProposal = action.payload.data;
      }
    );
  },
});

export const BusinessResourceReducer = BusinessResourceSlice.reducer;
